<template>
  <v-container
    fluid
    class="pa-0"
  >
    <v-row>
      <v-col
        cols="12"
        md="6"
      >
        <card-information-dynamic-field
          :loading="loading"
          :employee-information="employeeInformation"
        />
      </v-col>
    </v-row>
    <v-row
      v-if="loading"
    >
      <v-col
        cols="12"
      >
        <v-card>
          <v-card-title>
            <v-skeleton-loader
              v-if="loading"
              width="100%"
              type="text"
            />
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-skeleton-loader
                  v-if="loading"
                  width="100%"
                  type="table"
                />
              </v-col>
              <v-col cols="12">
                <v-skeleton-loader
                  v-if="loading"
                  width="100%"
                  type="table"
                  height="100"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        v-if="customerSeminarRelatedLevelId === 2"
        cols="12"
      >
        <v-card>
          <v-card-title>
            <div class="seminar-dialog-title-wrapper">
              {{ $t('employee_seminar_detail.attendance_info.title') }}
            </div>
            <div style="padding-bottom: 16px">
              <p
                class="mb-0 table-index-heading"
              >
                Index
              </p>
              <div
                v-for="(item) in tableIndexes"
                :key="item.id"
              >
                <a
                  class="table-index-heading-contents"
                  :href="item.link"
                  @click.prevent="scrollToTable(item.id)"
                >
                  <span class="table-index-content-icon">▼</span>
                  <span class="table-index-content-text"> {{ item.name }}</span>
                </a>
              </div>
            </div>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col
                cols="12"
              >
                <v-card elevation="1">
                  <v-card-title
                    id="road_top_seminar"
                    class="seminar-table-title"
                    :style="$vuetify.breakpoint.xs ? 'border-bottom: thin solid rgba(0,0,0,.12); font-size: 18px;' : ''"
                  >
                    {{ $t('employee_seminar_detail.attendance_info.road_to_top_attendance_status') }}
                  </v-card-title>
                  <seminar-detail-table
                    :loading="loading"
                    :contents="seminarApexContents"
                    :headers="seminarApexHeaders"
                    :main-columns="['seminar_name']"
                  />
                </v-card>
              </v-col>
              <v-col
                cols="12"
                class="seminar-table-bottom-title"
              >
                <span>{{ $t('employee_seminar_detail.attendance_status_note') }}</span>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-card elevation="1">
                  <v-card-title
                    id="standard_atc_seminar"
                    class="seminar-table-title"
                    :style="$vuetify.breakpoint.xs ? 'border-bottom: thin solid rgba(0,0,0,.12); font-size: 18px;' : ''"
                  >
                    {{ $t('employee_seminar_detail.attendance_info.standard_atc_attendance_status') }}
                  </v-card-title>
                  <seminar-detail-table
                    :loading="loading"
                    :contents="seminarStandardContents"
                    :headers="seminarStandardHeaders"
                    :main-columns="['attended_count']"
                  />
                </v-card>
              </v-col>
              <v-col
                cols="12"
                class="seminar-table-bottom-title"
              >
                <span>{{ $t('employee_seminar_detail.attendance_status_note') }}</span>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col
        v-if="customerSeminarRelatedLevelId === 2 || customerSeminarRelatedLevelId === 1"
        cols="12"
      >
        <v-card>
          <v-card-title id="history_seminar">
            <div class="seminar-dialog-title-wrapper">
              {{ $t('employee_seminar_detail.attendance_history.title') }}
            </div>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-card elevation="1">
                  <seminar-detail-table
                    :loading="loading"
                    :contents="seminarAttendanceHistoryContents"
                    :headers="seminarAttendanceHistoryHeaders"
                    :main-columns="['venue', 'seminar_name']"
                  />
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col
        v-if="customerSeminarRelatedLevelId === 2"
        cols="12"
      >
        <v-card>
          <v-card-title id="assistant_seminar">
            <div class="seminar-dialog-title-wrapper">
              {{ $t('employee_seminar_detail.assistant_history.title') }}
            </div>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col
                cols="12"
              >
                <v-card elevation="1">
                  <seminar-detail-table
                    :loading="loading"
                    :contents="seminarAssistantHistoryContents"
                    :headers="seminarAssistantHistoryHeaders"
                    :main-columns="['venue', 'seminar_name']"
                  />
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import QUATSError from '../../../plugins/error'
import SeminarDetailTable from './SeminarDetailTable.vue'
import CardInformationDynamicField from '../../../components/CardInformationDynamicField.vue'

export default {
  name: 'EmployeeSeminarInfoDetail',
  components: {
    CardInformationDynamicField,
    SeminarDetailTable
  },
  data () {
    return {
      loading: false,
      customerRelatedLevelId: 0,
      seminarApexContents: [],
      seminarStandardContents: [],
      seminarAttendanceHistoryContents: [],
      seminarAssistantHistoryContents: [],
      employeeInformation: []
    }
  },
  computed: {
    tableIndexes() {
      return [
        {
          id: 'road_top_seminar',
          name: this.$t('employee_seminar_detail.attendance_info.road_to_top_attendance_status'),
          link: '#road_top_seminar'
        },
        {
          id: 'standard_atc_seminar',
          name: this.$t('employee_seminar_detail.attendance_info.standard_atc_attendance_status'),
          link: '#standard_atc_seminar'
        },
        {
          id: 'history_seminar',
          name: this.$t('employee_seminar_detail.attendance_history.title'),
          link: '#history_seminar'
        },
        {
          id: 'assistant_seminar',
          name: this.$t('employee_seminar_detail.assistant_history.title'),
          link: '#assistant_seminar'
        },
      ]
    },
    customerSeminarRelatedLevelId() {
      return this.customerRelatedLevelId
    },
    seminarApexHeaders() {
      return [
        { text: this.$t('employee_seminar_detail.attendance_info.course_name_header'), align: 'start', value: 'seminar_name', sortable: false, divider: true,  width: '200px', class: 'seminar-dialog-table-header' },
        { text: this.$t('employee_seminar_detail.attendance_info.attendance_status_header'), align: 'start', value: 'attendance_status', sortable: false, divider: true , width: '160px', class: 'seminar-dialog-table-header'},
        { text: this.$t('employee_seminar_detail.course_report'), align: 'start', value: 'questionnaire_contents', sortable: false, width: '160px', divider: false, class: 'seminar-dialog-table-header-last'},
      ]
    },
    seminarStandardHeaders() {
      return [
        { text: this.$t('employee_seminar_detail.attendance_info.standard_atc_attendances_header'), align: 'start', value: 'attended_count', sortable: false, divider: true, width: '200px', class: 'seminar-dialog-table-header' },
        { text: this.$t('employee_seminar_detail.attendance_info.attendance_status_header'), align: 'start', value: 'attendance_status', sortable: false, divider: true , width: '160px', class: 'seminar-dialog-table-header'},
        { text: this.$t('employee_seminar_detail.course_report'), align: 'start', value: 'questionnaire_contents', sortable: false, divider: false, width: '160px', class: 'seminar-dialog-table-header-last'},
      ]
    },
    seminarAttendanceHistoryHeaders() {
      return [
        { text: this.$t('employee_seminar_detail.attendance_history.schedule_header'), align: 'start', value: 'schedule', sortable: false, divider: true,  width: '130px', class: 'seminar-dialog-table-header' },
        { text: this.$t('employee_seminar_detail.attendance_history.venue_header'), align: 'start', value: 'place_name', sortable: false, divider: true , width: '100px', class: 'seminar-dialog-table-header'},
        { text: this.$t('employee_seminar_detail.attendance_history.seminar_name_header'), align: 'start', value: 'seminar_name', sortable: false, divider: true , width: '200px', class: 'seminar-dialog-table-header-last'},
        // { text: this.$t('employee_seminar_detail.course_report'), align: 'center', value: 'form', sortable: false, width: '160px', divider: false, class: 'seminar-dialog-table-header-last'},
      ]
    },
    seminarAssistantHistoryHeaders() {
      return [
        { text: this.$t('employee_seminar_detail.attendance_history.schedule_header'), align: 'start', value: 'schedule', sortable: false, divider: true,  width: '130px', class: 'seminar-dialog-table-header' },
        { text: this.$t('employee_seminar_detail.attendance_history.venue_header'), align: 'start', value: 'place_name', sortable: false, divider: true , width: '100px', class: 'seminar-dialog-table-header'},
        { text: this.$t('employee_seminar_detail.attendance_history.seminar_name_header'), align: 'start', value: 'seminar_name', sortable: false, divider: true , width: '200px', class: 'seminar-dialog-table-header-last'},
        // { text: this.$t('employee_seminar_detail.assistant_history.situation_header'), align: 'center', value: 'situation', sortable: false, width: '160px', divider: false, class: 'seminar-dialog-table-header-last'},
      ]
    }
  },
  created() {
    if(this.$store.state.account.user) {
      this.loading = true
      const customerId = this.$router.currentRoute.params.id
      const promises = [
        window.axios.get(`/api/employee-seminar-info/seminar-detail/employee?customer_id=${customerId}`),
      ]
      return Promise.all(promises)
        .then(results => {
          this.arrangeEmployeeSeminarData(results[0]?.data?.data?.data)
        }).catch(err => {
          this.loading = false
          this.$store.commit('snackbar/errorSnackbar', [new QUATSError(this.$i18n, err).message])
        })
    }
  },
  methods: {
    arrangeEmployeeSeminarData(data) {
      this.employeeInformation = [
        { label: 'name', value: data.customer_name },
        { label: 'id', value: data.customer_id },
        { label: 'disclosure_level', value: data.relation_level_division_id }
      ]

      this.customerRelatedLevelId = data.relation_level_division_id

      this.seminarApexContents = data.apex_series_seminar_histories
      this.seminarStandardContents = data.atc_histories
      this.seminarAttendanceHistoryContents = data.not_apex_series_seminar_histories
      this.seminarAssistantHistoryContents = data.assistant_seminar_histories

      this.loading = false
    },
    scrollToTable(tableId) {
      const element = document.getElementById(tableId)
      if (element) {
        element.scrollIntoView({behavior: 'smooth'})
      }
    }
  }
}
</script>

<style scoped>
::v-deep .seminar-table-title {
  padding-left: 16px;
  font-size: 18px;
  font-weight: 600;
}

::v-deep .seminar-table-bottom-title {
  padding-top: 0;
  font-size: 14px;
  color: grey;
}

::v-deep .seminar-dialog-title-wrapper {
  min-height: 44px;
  font-size: 22px;
  background: #fff;
  color: #072a67;
  font-weight: 600;
  display: -ms-flexbox;
  display: flex;
  margin-bottom: 16px;
  -ms-flex-align: center;
  align-items: center;
  border-bottom: 4px solid #f5f5f5;
  border-radius: 2px;
  position: relative;
  width: 100%;
}

::v-deep .seminar-dialog-title-wrapper:before {
  content: '';
  position: absolute;
  width: 60px;
  height: 4px;
  background: #072a67;
  bottom: -4px;
  left: 0;
  border-radius: 4px;
}
::v-deep .v-skeleton-loader__table-tfoot .v-skeleton-loader__bone {
  display: none;
}

@media (max-width: 844px) {
  ::v-deep .v-skeleton-loader__table-row-divider .v-skeleton-loader__table-row  .v-skeleton-loader__table-cell {
    width: 40px !important;
  }
}

.table-index-heading {
  font-size: 16px;
  font-weight: 700;
}

.table-index-heading-contents {
  padding-left: 16px;
  font-size: 14px;
}

.table-index-content-icon {
  font-size: 15px;
}

.table-index-content-text {
  text-decoration: underline;
}
</style>
